jQuery(function($) {
	//Sliders
	$('.case-stadies-slider').slick({
		infinite: true,
		centerPadding: '5%',
  		slidesToShow: 1,
		rtl: $('html').attr('dir') === 'rtl',
		dots: true
	});
	if ($(window).width() > 768) {
		$('.review-slider').on('init afterChange', function(){
			$('.review-slider .slick-slide').css('opacity', 0.5).attr('aria-hidden', 'true');
			$('.review-slider .slick-current').css('opacity', 1).removeAttr('aria-hidden');
			$('.review-slider .slick-current').next().css('opacity', 1).removeAttr('aria-hidden');
		});
	} 
	$('.review-slider').on('init afterChange', function(){
		let maxHeight = 0;
		$('.review-slider .slick-slide').each(function() {
			let slideHeight = $(this).outerHeight();
			if (slideHeight > maxHeight) {
				maxHeight = slideHeight;
			}
		});
		$('.review-slider .slick-slide > div').css('height', maxHeight + 'px');
	});

	$('.review-slider').slick({
		infinite: true,
  		slidesToShow: 2,
		centerMode: false,
		rtl: $('html').attr('dir') === 'rtl',
		focusOnSelect: true,
		responsive: [			
			{
			  	breakpoint: 992,
			  	settings: {
					slidesToShow: 1,
			  }
			}						
		]
	});
	$('.blog-slider').slick({
		infinite: true,
  		slidesToShow: 3,
		rtl: $('html').attr('dir') === 'rtl',
		responsive: [
			{
			  breakpoint: 992,
			  settings: {
				slidesToShow: 1,
			  }
			},						
		]
	});
});

jQuery(function($) {
	function setEqualHeight() {
		const blocks = $('.equalize-height');
		let maxHeight = -1;
		blocks.each(function() {
			let blockHeight = $(this).outerHeight();
			maxHeight = Math.max(maxHeight, blockHeight);
		});
		blocks.outerHeight(maxHeight);
	}
	$(window).on('load resize', setEqualHeight);
});

jQuery(function($) {
	$(window).on('scroll', function() {
		$('.scroll-container .scroll-item').each(function() {
			let $element = $(this);
			let windowHeight = $(window).height();
			let scrollTop = $(window).scrollTop();
			let elementOffsetTop = $element.offset().top;
			let elementHeight = $element.outerHeight();
	
			let elementTopInView = elementOffsetTop - scrollTop;
			let elementBottomInView = elementTopInView + elementHeight;
	
			let topThreshold = windowHeight * 0.05;
			let bottomThreshold = windowHeight * 0.95;
	
			if (elementTopInView >= topThreshold && elementBottomInView <= bottomThreshold) {
				$element.removeClass('gray-opacity');
			} 
			else if (elementTopInView < topThreshold || elementBottomInView > bottomThreshold) {
				$element.addClass('gray-opacity');
			}
		});
	});
});

jQuery(function($) {
		//Accordion
		$(document).ready(function ($) {
			$('.home .home-accordion-with-image .accordion-item:first-child .accordion-collapse').collapse({"toggle": false,});
		});

		$('.home-accordion-with-image .accordion-button').on('click', function(e){
			if($(this).hasClass( "collapsed" )) {
				let target = $(this).data().bsTarget;
				$(target).addClass('show');
				$(this).removeClass('collapsed');
			}
		});
});